<template>
  <bb-modal
    :visible="visible"
    flavor="card"
    public-size="m"
    full-mobile
    @close="onClose"
  >
    <template #heading>
      <span class="f-small f-color-blue">
        {{ $t('smartIdPlusModal.title') }}
      </span>
    </template>
    <bb-banner
      type="info"
      banner-style="filled"
      permanent
      visible
    >
      <p class="f-small">
        {{ $t('smartIdPlusModal.infoBannerText') }}
      </p>
      <bb-link
        class="f-small"
        color="blue"
        target="_blank"
        :label="$t('smartIdPlusModal.infoBannerLinkText')"
        :to="aboutSmartIdPlusLink"
      />
    </bb-banner>
    <p
      v-if="!isMobileDevice || !isQrCodeVisible"
      class="m-t-15 f-small f-color-gray-80 text-center"
    >
      {{ $t('smartIdPlusModal.instructionText') }}
    </p>
    <div
      v-if="isQrCodeVisible"
      class="text-center"
      :class="isMobileDevice ? 'm-t-30' : 'm-t-15'"
    >
      <qrcode-vue
        class="m-b-15 p-20 border-style-solid border-width-1 border-gray-30 border-radius-lg"
        style="display: inline-block;"
        size="220"
        :value="qrCode"
      />
      <p class="f-small color-gray-80">
        {{ $t('smartIdPlusModal.qrNote') }}
      </p>
      <bb-link
        class="f-small"
        color="blue"
        target="_blank"
        :label="$t('smartIdPlusModal.appLinkText')"
        :to="updateSmartIdAppLink"
      />
    </div>
    <bb-button
      v-if="isMobileDevice"
      class="m-t-30 w-100"
      :label="$t('smartIdPlusModal.openAppButton')"
      @click="openSmartIdApp"
    />
    <div
      v-if="isMobileDevice && !isQrCodeVisible"
      class="m-t-30 text-center"
    >
      <p class="m-b-10 f-small color-gray">
        {{ $t('smartIdPlusModal.openQrText') }}
      </p>
      <bb-button
        class="w-100"
        color="blue"
        inverted
        :label="$t('smartIdPlusModal.openQrButton')"
        @click="showQrCode"
      />
    </div>
    <bb-banner
      class="m-t-30"
      type="warning"
      banner-style="filled"
      permanent
      visible
    >
      <span class="f-small">
        {{ $t('smartIdPlusModal.warningBannerText') }}
      </span>
    </bb-banner>
  </bb-modal>
</template>
<script>
  import { Languages } from '@/types/common/enums';
  import { AboutSmartIdPlusLink, UpdateSmartIdAppLink } from '@/constants/common/constants';
  import { BbModal, BbBanner, BbLink, BbButton } from '@bigbank/interface-components';
  import QrcodeVue from 'qrcode.vue';
  import { isMobileDevice } from '@/utils/common/customerDevice';

  export default {
    name: 'smart-id-plus-modal',
    components: {
      BbModal,
      BbBanner,
      BbLink,
      BbButton,
      QrcodeVue,
    },
    props: {
      visible: Boolean,
      qrCode: String,
    },
    data() {
      return {
        isMobileDevice: isMobileDevice(),
        isQrCodeVisible: !isMobileDevice(),
      };
    },
    computed: {
      language() {
        return this.$i18n.locale;
      },
      aboutSmartIdPlusLink() {
        return AboutSmartIdPlusLink[this.language] ?? AboutSmartIdPlusLink[Languages.en];
      },
      updateSmartIdAppLink() {
        return UpdateSmartIdAppLink[this.language] ?? UpdateSmartIdAppLink[Languages.en];
      },
    },
    watch: {
      visible(value) {
        if (!this.isMobileDevice && value) {
          this.$emit('initiate-authentication');
        }
      },
    },
    methods: {
      openSmartIdApp() {
        this.$emit('open-mobile-app');
      },
      showQrCode() {
        this.$emit('initiate-authentication');
        this.isQrCodeVisible = true;
      },
      onClose() {
        this.isQrCodeVisible = !this.isMobileDevice;
        this.$emit('close');
      },
    },
  };
</script>
